module.exports = __webpack_public_path__ + "img/top.ad60d801.png";